export class CorpModel {
  label: string;
  id: string;
  logo: string | undefined;
  createdBy: string;
  inactive: boolean;
}
